import React from "react";
import { useState } from "react";
import DateHelpers from "../Helper/DateHelpers";
import '../Styles/PersonalInfo.scss';
import '../Styles/FamilyCampPersonalInfo.scss';
import InputValidation from "../Helper/InputValidation";
import { getLadderPrice, canAddFamilyMember, getAttendeeCount, DELUXE_MAX_CAMPERS }
   from "../Constants/FamilyCampConfig";

// Personal info for the registrant, plus the Add Family Member section — the same "add another
// row" pattern FatherSonPersonalInfo uses for sons, except each row also takes a birth date and
// shows that member's own price, since Family Camp prices every position on the ladder
// differently rather than charging everyone the same flat per-son fee.
function FamilyCampPersonalInfo({ week, roomType, personalInformation, setPersonalInformation,
   selectedPage, setSelectedPage, previousPage, nextPage }) {

   const [invalidGenderError, setInvalidGenderError] = useState(false)
   const [invalidFirstNameError, setInvalidFirstNameError] = useState(false)
   const [invalidLastNameError, setInvalidLastNameError] = useState(false)
   const [invalidStreetAddress, setInvalidStreetAddress] = useState(false)
   const [invalidCity, setInvalidCity] = useState(false)
   const [invalidState, setInvalidState] = useState(false)
   const [invalidZip, setInvalidZip] = useState(false)
   const [invalidZipFormat, setInvalidZipFormat] = useState(false)
   const [invalidPhone, setInvalidPhone] = useState(false)
   const [invalidPhoneFormat, setInvalidPhoneFormat] = useState(false)
   const [invalidBirthDate, setInvalidBirthDate] = useState(false)
   const [invalidECName, setInvalidECName] = useState(false)
   const [invalidECRelationship, setInvalidECRelationship] = useState(false)
   const [invalidECPhone, setInvalidECPhone] = useState(false)
   const [invalidECPhoneFormat, setInvalidECPhoneFormat] = useState(false)
   const [invalidFamilyMemberBirthDate, setInvalidFamilyMemberBirthDate] = useState(false)

   const familyMembers = personalInformation.familyMembers && personalInformation.familyMembers.length > 0
      ? personalInformation.familyMembers
      : [{ firstName: '', lastName: '', birthDate: '' }]

   const canAddMore = canAddFamilyMember(roomType, personalInformation)
   const attendeeCount = getAttendeeCount(personalInformation)

   function CalculateMinimumDate() {
      let minimumDate = DateHelpers.subtractFromDate(new Date(), 100)
      return DateHelpers.getFormattedDate(minimumDate)
   }

   function handleFamilyMemberChange(index, field, value) {
      const updated = [...familyMembers]
      updated[index] = { ...updated[index], [field]: value }
      setPersonalInformation({ ...personalInformation, familyMembers: updated })
      setInvalidFamilyMemberBirthDate(false)
   }

   function handleAddFamilyMember() {
      if (!canAddMore) {
         return
      }
      setPersonalInformation({ ...personalInformation, familyMembers: [...familyMembers, { firstName: '', lastName: '', birthDate: '' }] })
   }

   function ValidatePersonalInformation() {
      let isError = false;
      if (personalInformation.gender === "") {
         setInvalidGenderError(true)
         isError = true;
      }
      if (personalInformation.firstName === "") {
         setInvalidFirstNameError(true)
         isError = true
      }
      if (personalInformation.lastName === "") {
         setInvalidLastNameError(true)
         isError = true
      }
      if (personalInformation.strAddress === "") {
         setInvalidStreetAddress(true)
         isError = true
      }
      if (personalInformation.city === "") {
         setInvalidCity(true)
         isError = true
      }
      if (personalInformation.state === "") {
         setInvalidState(true)
         isError = true
      }
      if (personalInformation.zip === "") {
         setInvalidZip(true)
         isError = true
      }
      if (personalInformation.zip != "") {
         const condition = /^(?!00000)\d{5}(?:[-\s](?!0000)\d{4})?$/
         if (condition.test(personalInformation.zip) === false) {
            setInvalidZipFormat(true)
            isError = true
         }
      }
      if (personalInformation.phone === "") {
         setInvalidPhone(true)
         isError = true
      }
      if (personalInformation.phone != "") {
         const condition = /^\d{3}[ -]?\d{3}[ -]?\d{4}$/
         if (condition.test(personalInformation.phone) === false) {
            setInvalidPhoneFormat(true)
            isError = true
         }
      }
      if (personalInformation.birthDate === "") {
         setInvalidBirthDate(true)
         isError = true
      }
      if (personalInformation.ecName === "") {
         setInvalidECName(true)
         isError = true
      }
      if (personalInformation.ecRelationship === "") {
         setInvalidECRelationship(true)
         isError = true
      }
      if (personalInformation.ecPhone === "") {
         setInvalidECPhone(true)
         isError = true
      }
      if (personalInformation.ecPhone != "") {
         const condition = /^\d{3}[ -]?\d{3}[ -]?\d{4}$/
         if (condition.test(personalInformation.ecPhone) === false) {
            setInvalidECPhoneFormat(true)
            isError = true
         }
      }
      // A family member with a name but no birth date would otherwise reach checkout and fail the
      // database's NOT NULL constraint on family_member.birth_date — catch it here instead.
      const hasUnbornMember = familyMembers.some(member => {
         const hasName = (member?.firstName ?? '').trim().length > 0 || (member?.lastName ?? '').trim().length > 0
         return hasName && (member?.birthDate ?? '').trim().length === 0
      })
      if (hasUnbornMember) {
         setInvalidFamilyMemberBirthDate(true)
         isError = true
      }
      if (isError === false) {
         setSelectedPage(nextPage)
      }
   }

   return (
      <div className='personalInfoContent'>
         <form>
            <h2 id='personalInfoTitle'>Personal Info</h2>
            <div className="camperGender">
               {invalidGenderError === true &&
                  <div className="genderError">
                     * Gender is required
                  </div>
               }
               <div className='gender'>
                  <div className="MaleLabel">
                     <label id="male">Male</label>
                  </div>
                  <div className="Male">
                     <input
                        type="radio"
                        value="M"
                        name="fav_language"
                        checked={personalInformation.gender === "M"}
                        onChange={(e) => {
                           setPersonalInformation({ ...personalInformation, gender: (e.target.value) })
                           setInvalidGenderError(false)
                        }}
                     />
                  </div>
                  <div className='FemaleLabel'>
                     <label className="female">Female</label>
                  </div>
                  <div className="Female">
                     <input
                        type="radio"
                        value="F"
                        name="fav_language"
                        checked={personalInformation.gender === "F"}
                        onChange={(e) => {
                           setPersonalInformation({ ...personalInformation, gender: (e.target.value) })
                           setInvalidGenderError(false)
                        }}
                     />
                  </div>
               </div>
            </div>

            <div className='camperName'>
               <div className="firstName">
                  {invalidFirstNameError === true &&
                     <div className="firstNameError">
                        * First name is required
                     </div>
                  }
                  <label>First Name:* </label>
                  <input
                     type="text"
                     required
                     value={personalInformation.firstName}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, firstName: (e.target.value) });
                        setInvalidFirstNameError(false)
                     }}
                  />
               </div>

               <div className="lastName">
                  {invalidLastNameError === true &&
                     <div className="lastNameError">
                        * Last name is required
                     </div>
                  }
                  <label>Last Name:* </label>
                  <input
                     type="text"
                     required
                     value={personalInformation.lastName}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, lastName: (e.target.value) });
                        setInvalidLastNameError(false)
                     }}
                  />
               </div>
            </div>

            <div className="familyMembersRow">
               <label className="familyMembersRowLabel">
                  Add Family Members
               </label>
               <div className="familyMembersNote">
                  Add everyone attending with you. Each person added is priced individually, shown
                  next to their name as soon as you add them.
               </div>
               {invalidFamilyMemberBirthDate === true &&
                  <div className="familyMembersBirthDateError">
                     * Birth date is required for every family member listed
                  </div>
               }
               <div className="familyMembersHeaderRow">
                  <label className="familyMemberFirstName">First Name</label>
                  <label className="familyMemberLastName">Last Name</label>
                  <label className="familyMemberBirthDate">Date of Birth</label>
               </div>
               {familyMembers.map((member, index) => {
                  const position = index + 2
                  const price = getLadderPrice(roomType, position)
                  const hasName = (member.firstName ?? '').trim().length > 0 || (member.lastName ?? '').trim().length > 0
                  return (
                     <div className="familyMemberInputRow" key={index}>
                        <input
                           type="text"
                           placeholder="First Name"
                           className="familyMemberFirstName"
                           value={member.firstName}
                           onChange={(e) => handleFamilyMemberChange(index, 'firstName', e.target.value)}
                        />
                        <input
                           type="text"
                           placeholder="Last Name"
                           className="familyMemberLastName"
                           value={member.lastName}
                           onChange={(e) => handleFamilyMemberChange(index, 'lastName', e.target.value)}
                        />
                        <input
                           type="date"
                           className="familyMemberBirthDate"
                           max={DateHelpers.getFormattedDate(new Date())}
                           value={member.birthDate}
                           onChange={(e) => handleFamilyMemberChange(index, 'birthDate', e.target.value)}
                        />
                        {hasName &&
                           <div className="familyMemberPrice">
                              ${price.toFixed(2)}
                           </div>
                        }
                        {index === familyMembers.length - 1 &&
                           <button
                              type="button"
                              className="familyMembersAddButton"
                              onClick={handleAddFamilyMember}
                              disabled={!canAddMore}
                              aria-label="Add another family member"
                           >
                              +
                           </button>
                        }
                     </div>
                  )
               })}
               {!canAddMore &&
                  <div className="familyMembersCapNotice">
                     Deluxe rooms are limited to {DELUXE_MAX_CAMPERS} people total. Choose Standard
                     on the previous step to add more.
                  </div>
               }
               {attendeeCount > 1 &&
                  <div className="familyMembersSubtotal">
                     {attendeeCount} people on this registration
                  </div>
               }
            </div>

            <div className='streetCity'>
               <div className="addressInput">
                  {invalidStreetAddress === true &&
                     <div className="streetAddressError">
                        * Address is required
                     </div>
                  }
                  <label>Street Address:* </label>
                  <input
                     type="text"
                     required
                     value={personalInformation.strAddress}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, strAddress: (e.target.value) })
                        setInvalidStreetAddress(false)
                     }}
                  />
               </div>
               <div className="addressInput">
                  {invalidCity === true &&
                     <div className="cityError">
                        * City is required
                     </div>
                  }
                  <label>City:* </label>
                  <input
                     type="text"
                     required
                     value={personalInformation.city}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, city: (e.target.value) })
                        setInvalidCity(false)
                     }}
                  />
               </div>
            </div>
            <div className="stateZip">
               <div className="stateInput">
                  {invalidState === true &&
                     <div className="stateError">
                        * State is required
                     </div>
                  }
                  <label for="state">State: </label>
                  <select
                     value={personalInformation.state}
                     defaultValue={personalInformation.state}
                     onChange={event => {
                        setPersonalInformation({ ...personalInformation, state: (event.target.value) })
                        setInvalidState(false)
                     }}
                     id="state"
                     name="state">
                     <option value="---">---</option>
                     <option value="Alabama">Alabama</option>
                     <option value="Alaska">Alaska</option>
                     <option value="Arizona">Arizona</option>
                     <option value="Arkansas">Arkansas</option>
                     <option value="California">California</option>
                     <option value="Colorado">Colorado</option>
                     <option value="Connecticut">Connecticut</option>
                     <option value="Delaware">Delaware</option>
                     <option value="District of Columbia">District of Columbia</option>
                     <option value="Florida">Florida</option>
                     <option value="Georgia">Georgia</option>
                     <option value="Guam">Guam</option>
                     <option value="Hawaii">Hawaii</option>
                     <option value="Idaho">Idaho</option>
                     <option value="Illinois">Illinois</option>
                     <option value="Indiana">Indiana</option>
                     <option value="Iowa">Iowa</option>
                     <option value="Kansas">Kansas</option>
                     <option value="Kentucky">Kentucky</option>
                     <option value="Louisiana">Louisiana</option>
                     <option value="Maine">Maine</option>
                     <option value="Maryland">Maryland</option>
                     <option value="Massachusetts">Massachusetts</option>
                     <option value="Michigan">Michigan</option>
                     <option value="Minnesota">Minnesota</option>
                     <option value="Mississippi">Mississippi</option>
                     <option value="Missouri">Missouri</option>
                     <option value="Montana">Montana</option>
                     <option value="Nebraska">Nebraska</option>
                     <option value="Nevada">Nevada</option>
                     <option value="New Hampshire">New Hampshire</option>
                     <option value="New Jersey">New Jersey</option>
                     <option value="New Mexico">New Mexico</option>
                     <option value="New York">New York</option>
                     <option value="North Carolina">North Carolina</option>
                     <option value="North Dakota">North Dakota</option>
                     <option value="Northern Marianas Islands">Northern Marianas Islands</option>
                     <option value="Ohio">Ohio</option><option value="Oklahoma">Oklahoma</option>
                     <option value="Oregon">Oregon</option>
                     <option value="Pennsylvania">Pennsylvania</option>
                     <option value="Puerto Rico">Puerto Rico</option>
                     <option value="Rhode Island">Rhode Island</option>
                     <option value="South Carolina">South Carolina</option>
                     <option value="South Dakota">South Dakota</option>
                     <option value="Tennessee">Tennessee</option>
                     <option value="Texas">Texas</option>
                     <option value="Utah">Utah</option>
                     <option value="Vermont">Vermont</option>
                     <option value="Virginia">Virginia</option>
                     <option value="Virgin Islands">Virgin Islands</option>
                     <option value="Washington">Washington</option>
                     <option value="West Virginia">West Virginia</option>
                     <option value="Wisconsin">Wisconsin</option>
                     <option value="Wyoming">Wyoming</option>
                  </select>
               </div>
               <div className="zipInput">
                  {invalidZip === true &&
                     <div className="zipError">
                        * Zip code is required
                     </div>
                  }
                  {invalidZipFormat === true &&
                     <div className="zipFormatError">
                        * Zip code must be formatted as such: 12345, 12345 6789, or 12345-6789
                     </div>
                  }
                  <label>Zip:* </label>
                  <input
                     type="text"
                     required
                     maxLength={10}
                     value={personalInformation.zip}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, zip: InputValidation.ValidateInputForPhoneAndZipCode(e.target.value) })
                        setInvalidZip(false)
                        setInvalidZipFormat(false)
                     }} />
               </div>
            </div>
            <div className='camperContact'>
               <div className="contactInput">
                  {invalidPhone === true &&
                     <div className="phoneError">
                        * Phone number is required
                     </div>
                  }
                  {invalidPhoneFormat === true &&
                     <div className="phoneFormatError">
                        * Phone number must be formatted as such: 1234567890, 123 456 7890, or 123-456-7890
                     </div>
                  }
                  <label>Cell Phone #:* </label>
                  <input
                     type="text"
                     required
                     maxLength={12}
                     value={personalInformation.phone}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, phone: InputValidation.ValidateInputForPhoneAndZipCode(e.target.value) })
                        setInvalidPhone(false)
                        setInvalidPhoneFormat(false)
                     }} />
               </div>
               <div className="dateOfBirthInput">
                  {invalidBirthDate === true &&
                     <div className="birthDateError">
                        * Birth date is required
                     </div>
                  }
                  <label>Birthdate :*</label>
                  <input
                     type="date"
                     required
                     min={CalculateMinimumDate()}
                     value={personalInformation.birthDate}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, birthDate: (e.target.value) })
                        setInvalidBirthDate(false)
                     }} />
               </div>
            </div>
            <hr></hr>
            <h4>Emergency Contact Info</h4>
            <div className='camperEmergencyContact'>
               <div className="ecInput">
                  {invalidECName === true &&
                     <div className="ecNameError">
                        * Contact name is required
                     </div>
                  }
                  <label>Name (First Last): * </label>
                  <input
                     type="text"
                     required
                     value={personalInformation.ecName}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, ecName: (e.target.value) })
                        setInvalidECName(false)
                     }} />
               </div>

               <div className="ecInput">
                  {invalidECRelationship === true &&
                     <div className="ecRelationshipError">
                        * Contact relationship is required
                     </div>
                  }
                  <label>Relationship:* </label>
                  <input
                     type="text"
                     required
                     value={personalInformation.ecRelationship}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, ecRelationship: (e.target.value) })
                        setInvalidECRelationship(false)
                     }} />
               </div>

               <div className="ecInput">
                  {invalidECPhone === true &&
                     <div className="ecPhoneError">
                        * Contact phone number is required
                     </div>
                  }
                  {invalidECPhoneFormat === true &&
                     <div className="ecPhoneFormatError">
                        * Phone number must be formatted as such: 1234567890, 123 456 7890, or 123-456-7890
                     </div>
                  }
                  <label>Phone Number:* </label>
                  <input
                     type="tel"
                     id="phone"
                     name="phone"
                     pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                     maxLength={12}
                     required
                     value={personalInformation.ecPhone}
                     onChange={(e) => {
                        setPersonalInformation({ ...personalInformation, ecPhone: InputValidation.ValidateInputForPhoneAndZipCode(e.target.value) })
                        setInvalidECPhone(false)
                        setInvalidECPhoneFormat(false)
                     }}
                  />
               </div>
            </div>

            <div className="disclaimerPI">
               <>* Fields are required</>
            </div>
         </form>
         {(
            invalidFirstNameError === true  || invalidLastNameError === true ||
            invalidCity === true            || invalidState === true         ||
            invalidZip === true             || invalidZipFormat === true     ||
            invalidPhone === true           || invalidPhoneFormat === true   ||
            invalidBirthDate === true       || invalidECName === true        ||
            invalidECRelationship === true  || invalidECPhone === true       ||
            invalidECPhoneFormat === true   || invalidGenderError === true   ||
            invalidFamilyMemberBirthDate === true) &&
            <div className="personalInfoErrorMessage">
               Please correct the above error(s):
            </div>
         }
         <div className="personalInfoButtonsContainer">
            <div className="personalInfoButtons">
               <div className="personalInfoPreviousButton">
                  <button className='prevButton' onClick={() => setSelectedPage(previousPage)}>
                     Previous
                  </button>
               </div>
               <div className="personalInfoNextButton">
                  <button className="nextButton" onClick={() => ValidatePersonalInformation()}>
                     Next
                  </button>
               </div>
            </div>
         </div>
      </div>
   )
}
export default FamilyCampPersonalInfo;
